<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title> {{(getNomenclatura(tipo) | nomenclatura | async)}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>


<ion-content class="schedule-content" *ngIf="loaded">
  <div class="gradient-extendido">
    <ion-segment mode="ios" class="segment-gradient-title" [(ngModel)]="grupoTab"
      (ionChange)="onSegmentChanged($event)" [scrollable]="true" value="inicio">
      <ion-segment-button value="inicio">
        <ion-label class="header">{{'Info' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="mensagem">
        <ion-label class="header">{{'Mensagens' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="reuniao">
        <ion-label class="header">{{'Reunião' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button *ngIf="grupo.permissaoEditar || admin" value="gerenciar">
        <ion-label class="header">{{'Gerenciar' | translate}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <div [ngSwitch]="grupoTab">
    <div *ngSwitchCase="'inicio'">
      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-clipboard-list div-icon"></i>
          </ion-note>

          <ion-label class="color-title">
            {{'Dados ' | translate}}
            {{(getNomenclatura(tipo) | nomenclatura | async)}}
          </ion-label>
        </div>

        <ion-card style="border-radius: 26px;">
          <ion-card-header>
            <ion-row>
              <ion-col size="auto">
                <div class="box-icon">
                  <i class="fas fa-user-friends icon-list"></i>
                </div>
              </ion-col>

              <ion-col>
                <ion-card-title>{{grupo.nome}}</ion-card-title>
                <ion-card-subtitle>{{grupo.grupoTipo}}</ion-card-subtitle>
              </ion-col>

              <ion-col size="auto" *ngIf="(grupo.permissaoEditar && !userProvider.hasConfig(21))">
                <div>
                  <i class="fa-regular fa-pen-circle icon-list" (click)="editarDados(grupo.id);"></i>
                </div>
              </ion-col>
            </ion-row>
          </ion-card-header>

          <ion-card-content>
            <ion-row>
              <ion-col size="6" style="display: flex;">
                <ion-icon class="icon-card" name="phone-portrait"></ion-icon>

                <p class="endereco-detalhes">
                  {{grupo.telCelular | phone:grupo.ddiTelCelular }}
                </p>
              </ion-col>

              <ion-col size="6" style="display: flex;">
                <ion-icon class="icon-card" name="call"></ion-icon>

                <p class="endereco-detalhes">
                  {{grupo.telResidencial | phone:grupo.ddiTelResidencial }}
                </p>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" style="display: flex;">
                <ion-icon class="icon-card" name="mail"></ion-icon>

                <p class="endereco-detalhes">
                  {{grupo.email ? grupo.email : ('Não Informado' | translate)
                  }}
                </p>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col size="12" style="display: flex;">
                <ion-icon [ngStyle]="{'color': grupo.ciclo_cor}" class="icon-card" name="refresh-circle"></ion-icon>

                <p class="endereco-detalhes">
                  {{grupo.ciclo ? grupo.ciclo : ('Não Informado' |
                  translate) }}
                </p>
              </ion-col>
            </ion-row>

            <ion-row>
              <ion-col style="display: flex;">
                <i class="fas fa-location-arrow icon-card"></i>

                <p class="endereco-detalhes">
                  {{endereco | endereco}}, {{endereco.regiaoNome}}
                </p>

                <p *ngIf="!endereco">
                  {{'Não Informado' | translate}}
                </p>
              </ion-col>

              <ion-col size="auto" *ngIf="(grupo.permissaoEditar && !userProvider.hasConfig(21))">
                <div>
                  <i class="fa-regular fa-pen-circle icon-list" (click)="editarEndereco(grupo.id);"></i>
                </div>
              </ion-col>
            </ion-row>

            <div *ngIf="endereco.logradouro">
              <ion-card class="endereco-maps">
                <img class="img-row" src="../../../assets/imgs/instituicao/maps.png" />

                <ion-card-content (click)="abrirMapa(endereco)">
                  <ion-row>
                    <ion-col size="5">
                      <div>

                        <a class="maps">
                          {{'Ver no mapa' | translate}}
                        </a>
                      </div>
                    </ion-col>

                    <ion-col>
                      <i class="fa-regular fa-chevron-right icon-endereco"></i>
                    </ion-col>
                  </ion-row>
                </ion-card-content>
              </ion-card>
            </div>
          </ion-card-content>
        </ion-card>


        <div style="padding: 25px 0px 35px 0px;border-bottom: solid 1px #e1e1e1;">
          <ion-row style="padding: 1px 19px 0px 19px; display: flex;">
            <ion-col>
              <i class="fas fa-clock div-icon" style="margin-top: 2px;"></i>

              <ion-label class="color-title" style="font-size: 18px !important; margin-top: 2px;">
                {{'Horários de Encontro' | translate}}
              </ion-label>
            </ion-col>

            <ion-col size="auto" *ngIf="(grupo.permissaoEditar && !userProvider.hasConfig(21))">
              <div>
                <i class="fa-regular fa-pen-circle icon-list" (click)="editarHorarios(grupo.id);"></i>
              </div>
            </ion-col>
          </ion-row>

          <ion-card-content class="white remove-card remove-border pointer">
            <ion-list *ngFor="let h of grupo.horarios">
              <ion-item>
                <ion-label>
                  <ion-row no-padding class="content-row one-line">
                    <ion-col size="auto">
                      <div class="square-icon">
                        <i class="fas fa-clock icon-list"></i>
                      </div>
                    </ion-col>

                    <ion-col class="item-content">
                      <h3 class="item-title bold-2">{{h.diaSemana | translate}}</h3>

                      <div class="item-description">
                        <p class="funcao-nome" *ngIf="h.horarioInicio">{{'Das' | translate}}
                          {{h.horarioInicio}} {{'até' | translate}} {{h.horarioFim}}
                          {{h.frequenciaDias == 7 ? ('semanalmente' | translate) :
                          h.frequenciaDias == 14 ? ('a cada duas semanas' | translate) :
                          h.frequenciaDias == 30 ? ('mensalmente' | translate) :
                          '' }}</p>

                        <p class="description-text bold-1" *ngIf="!h.horarioInicio">{{'Não Infomado' | translate}}</p>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-label>
              </ion-item>
            </ion-list>

            <div *ngIf="!grupo.horarios">
              <div class="not-found bold-1">
                <p>
                  {{'Nenhum registro localizado' | translate}}
                </p>
              </div>
            </div>

          </ion-card-content>
        </div>

        <div style="padding: 25px 0px 35px 0px;border-bottom: solid 1px #e1e1e1;">
          <ion-row style="padding: 1px 8px 0px 28px; display: flex;">
            <ion-col>
              <i class="far fa-chart-bar div-icon" style="margin-top: 2px;"></i>

              <ion-label class="color-title" style="font-size: 18px !important; margin-top: 2px;">
                {{'Hierarquia ' | translate}}
                {{(getNomenclatura(tipo) | nomenclatura | async)}}
              </ion-label>
            </ion-col>

            <ion-col size="auto" *ngIf="(grupo.permissaoEditar && !userProvider.hasConfig(21))">
              <div>
                <i class="fa-regular fa-pen-circle icon-list" (click)="editarHierarquia(grupo.id);"></i>
              </div>
            </ion-col>
          </ion-row>

          <ion-card-content class="white remove-border remove-card pointer">

            <div *ngFor="let h of hierarquiaList">
              <ion-list *ngFor="let f of h.funcoes">
                <ion-item *ngIf="f.hierarquiaGrupoFuncao" class="avatar-square">
                  <ion-avatar slot="start">
                    <img [src]="f.hierarquiaGrupoFuncao.pessoa.foto | image:' '" />
                  </ion-avatar>

                  <ion-label>
                    <h3 *ngIf="f.hierarquiaGrupoFuncao.pessoa" class="item-title bold-2">
                      {{f.hierarquiaGrupoFuncao.pessoa.nome}}
                    </h3>

                    <div>
                      <p class="funcao-nome"> {{f.nome}} </p>
                    </div>
                  </ion-label>
                </ion-item>
              </ion-list>
            </div>

          </ion-card-content>
        </div>

        <div style="padding: 25px 0px 35px 0px;border-bottom: solid 1px #e1e1e1;">
          <ion-row style="padding: 1px 8px 0px 28px; display: flex;">
            <ion-col>
              <i class="fas fa-user-friends div-icon" style="margin-top: 2px;"></i>

              <ion-label class="color-title" style="font-size: 18px !important; margin-top: 2px;">
                {{'Participantes' | translate}}
              </ion-label>
            </ion-col>

            <ion-col size="auto" *ngIf="grupo.permissaoEditar || admin">
              <div 
                *ngIf="!userProvider.hasConfig(185)"
              >
                <i class="fa-regular fa-pen-circle icon-list" (click)="gerenciarParticipantes();"></i>
              </div>
            </ion-col>
          </ion-row>

          <ion-card-content class="white remove-card remove-border">
            <div class="list-mini">
              <ion-list *ngFor="let p of grupo.participantes">
                <ion-item class="avatar-square">
                  <ion-avatar slot="start" (click)="opcoesParticipantes(p)">
                    <img [src]="p.foto | image:' '" />
                  </ion-avatar>

                  <ion-label (click)="opcoesParticipantes(p)">
                    <h3 class="item-title bold-2">
                      <i class="fas fa-circle mda-circle" [ngClass]="{'red': userProvider.hasConfig(46) && (!p.hasDiscipulador && !p.hasDiscipulo), 
                        'orange': userProvider.hasConfig(46) && (p.hasDiscipulador != p.hasDiscipulo), 
                        'green': userProvider.hasConfig(46) && (p.hasDiscipulador && p.hasDiscipulo)}"></i>
                      {{p.nome}}
                    </h3>
                  </ion-label>

                  <div *ngIf="grupo.permissaoEditar || admin" class="percentual">
                    <circle-progress *ngIf="p.frequencia" [percent]="p.frequencia.percentual" [outerStrokeWidth]="3"
                      [space]="-2" [innerStrokeWidth]="0" [backgroundStrokeWidth]="0" [radius]="15" [animation]="true"
                      [animateTitle]="true" [animationDuration]="1000" [innerStrokeWidth]="2" [titleFontSize]="'10'"
                      [titleFontWeight]="'bold'" [outerStrokeColor]="'#4882c2'" [innerStrokeColor]="'#e7e8ea'"
                      [showBackground]="false" [outerStrokeGradient]="true" [outerStrokeGradientStopColor]="'#53a9ff'"
                      [showSubtitle]="false"></circle-progress>
                  </div>

                  <ion-note slot="end" (click)="opcoesParticipantes(p)"
                    *ngIf="grupo.permissaoEditar || admin || userProvider.hasConfig(103) || userProvider.hasConfig(104) || userProvider.hasConfig(105)">
                    <ion-icon name="ellipsis-vertical" class="icon-list"></ion-icon>
                  </ion-note>
                </ion-item>
              </ion-list>

              <div *ngIf="!grupo.participantes.length">
                <div class="not-found bold-1">
                  <p>
                    {{'Nenhum registro localizado' | translate}}
                  </p>
                </div>
              </div>
            </div>

          </ion-card-content>
        </div>

        <div style="padding: 25px 0px 35px 0px;border-bottom: solid 1px #e1e1e1;">
          <ion-row style="padding: 1px 8px 0px 28px; display: flex;">
            <ion-col>
              <i class="fas fa-user-clock div-icon" style="margin-top: 2px;"></i>

              <ion-label class="color-title" style="font-size: 18px !important; margin-top: 2px;">
                {{'Visitantes' | translate}}
              </ion-label>
            </ion-col>

            <ion-col size="auto" *ngIf="!userProvider.hasConfig(179) && grupo.permissaoEditar || admin">
              <div *ngIf="grupo.permissaoEditar && admin ||
                  userProvider.hasConfig(119) ||
                  userProvider.hasConfig(120) ||
                  userProvider.hasConfig(121) ||
                  userProvider.hasConfig(125)
                ">
                <i class="fa-regular fa-pen-circle icon-list" (click)="gerenciarVisitantes();"></i>
              </div>
            </ion-col>
          </ion-row>

          <ion-card-content class="remove-border remove-card">
            <div class="list-mini">
              <ion-list *ngFor="let p of grupo.visitantes">
                <ion-item (click)="opcoesParticipantes(p, true)" class="avatar-square">
                  <ion-avatar slot="start">
                    <img [src]="p.foto | image:' '" />
                  </ion-avatar>

                  <ion-label>
                    <h3 class="item-title bold-2">{{p.nome}}</h3>
                  </ion-label>

                  <ion-note slot="end" [hidden]="!grupo.permissaoEditar">
                    <ion-icon name="ellipsis-vertical" class="icon-list"></ion-icon>
                  </ion-note>
                </ion-item>
              </ion-list>

              <div *ngIf="!grupo.visitantes.length">
                <div class="not-found bold-1">
                  <p>
                    {{'Nenhum registro localizado' | translate}}
                  </p>
                </div>
              </div>
            </div>

          </ion-card-content>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'mensagem'" class="mensagem gradient-extendido-div">
      <div class="gradient-extendido-div">
        <ion-row 
          class="div-top" 
          *ngIf="grupo.mensagens.length > 0"
          style="padding: 30px 12px 3px 28px; display: flex;"
        >
          <ion-col size="1">
            <i class="fas fa-envelope div-icon" style="margin-top: 2px;"></i>
          </ion-col>

          <ion-col size="10">
            <ion-label class="color-title">
              {{'Minhas mensagens' | translate}}
            </ion-label>
          </ion-col>
        </ion-row>


        <div *ngIf="!grupo.mensagens.length">
          <ion-grid>
            <ion-row>
              <ion-col>
                <ion-list>
                  <sem-registro [text]="'Nenhum registro localizado'"></sem-registro>
                </ion-list>
              </ion-col>
            </ion-row>
          </ion-grid>
        </div>

        <ion-grid *ngIf="grupo.mensagens.length > 0">
          <ion-row>
            <ion-col size="12" *ngFor="let m of grupo.mensagens">
              <ion-list lines="full">
                <ion-item-sliding class="border-sliding">
                  <ion-item (click)="openMensagem(m)" style="border-right: 2px solid #ff0000;">
                    <ion-note slot="start">
                      <i *ngIf="m.dataLido" class="fas fa-envelope-open"></i>
                      <i *ngIf="!m.dataLido" class="fas fa-envelope close"></i>
                    </ion-note>
                    
                    <ion-label class="mensagem-detalhes">
                      <h2 class="text-list" [ngClass]="{'not-read': !m.dataLido}">{{m.titulo}}</h2>

                      <p class="text-list">
                        {{m.pessoa}}
                      </p>

                      <p [ngClass]="{'bold-2': !m.dataLido}">
                        {{ m.created_at | dateFormat:"dataHora" }}
                      </p>
                    </ion-label>

                    <ion-icon
                      class="icon-list"
                      slot="end"
                      name="chevron-forward-outline"
                    ></ion-icon>
                  </ion-item>

                  <ion-item-options side="end">
                    <ion-item-option
                      expandable
                      class="delete"
                      (click)="deleteOne(m.id)"
                    >
                      {{'Apagar' | translate}}
                    </ion-item-option>
                  </ion-item-options>
                </ion-item-sliding>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>

    <div *ngSwitchCase="'reuniao'">
      <div [ngSwitch]="grupoTabReuniao">
        <div *ngSwitchCase="'reunioesAtuais'">
          <div class="gradient-extendido-div">
            <div class="div-top">
              <ion-note slot="start">
                <i class="fa-solid fa-calendar-clock div-icon" style="margin-top: 2px;"></i>
              </ion-note>

              <ion-label class="color-title">
                {{'Próxima Reunião' | translate}}
              </ion-label>
            </div>

            <ion-card class="card-reuniao" *ngIf="grupo.proximaReuniao">
              <ion-grid>
                <ion-row class="border-row">
                  <ion-col>
                    <div>
                      <p class="titulo">
                        {{grupo.proximaReuniao.tema}}
                      </p>

                      <span class="data">
                        {{ grupo.proximaReuniao.data | dateFormat: 'media' }} - {{ grupo.proximaReuniao.dataInicio | dateFormat: 'hora' }}
                        - {{ grupo.proximaReuniao.dataFim | dateFormat: 'hora'}}
                      </span>
                    </div>
                  </ion-col>

                  <ion-col size="auto">
                    <div class="icone-bell" (click)="calendario(grupo.proximaReuniao);">
                      <i class="fa-solid fa-bell"></i>
                    </div>
                  </ion-col>
                </ion-row>

                <ion-row class="top=margin">
                  <ion-col *ngIf="!isPWA">
                    <span class="responsavel-reuniao">
                      {{grupo.proximaReuniao.responsavel ? grupo.proximaReuniao.responsavel : ('Não Informado' |
                      translate)}}
                    </span>
                  </ion-col>

                  <ion-col size="auto">
                    <div class="presenca">
                      <ion-icon class="icon-card" name="people"></ion-icon>

                      <span [hidden]="grupo.proximaReuniao.numPresentes >= 1">
                        {{'Sem presenças confirmadas' | translate}}
                      </span>

                      <span [hidden]="grupo.proximaReuniao.numPresentes == 0">
                        {{ grupo.proximaReuniao.numPresentes }} {{ (grupo.proximaReuniao.numPresentes > 1 ? 'Convidados' : 'Convidado') | translate }}!
                      </span>
                    </div>
                  </ion-col>
                </ion-row>

                <ion-row>
                  <ion-col size="6" size-md="4" size-lg="5">
                    <div margin-top
                      [hidden]="grupo.presencaConfirmada == -1 || grupo.presencaConfirmada == 1 || userProvider.hasConfig(192)">
                      <ion-button class="btn-default" expand="block"
                        (click)="confirmar(1, grupo.id, grupo.proximaReuniao.id)" style="font-size: 12px !important;">
                        {{'Confirmar Presença' | translate}}
                      </ion-button>
                    </div>

                    <div [hidden]="grupo.presencaConfirmada == -1 || grupo.presencaConfirmada == 0">
                      <ion-button class="btn-default" expand="block"
                        (click)="confirmar(0, grupo.id, grupo.proximaReuniao.id)" style="font-size: 12px !important;">
                        {{'Cancelar Presença' | translate}}
                      </ion-button>
                    </div>
                  </ion-col>

                  <ion-col size="6" size-md="4" size-lg="5">
                    <div *ngIf="
                      grupo.proximaReuniao.pauta && (!userProvider.hasConfig(111)
                      || (userProvider.hasConfig(111) && grupo.permissaoEditar));
                    ">
                      <ion-button
                        class="btn-pauta"
                        expand="block"
                        size="default"
                        fill="outline"
                        (click)="abrirPauta(grupo.proximaReuniao)"
                        style="font-size: 12px !important;"
                      >
                        {{'Viusalizar Pauta' | translate}}
                      </ion-button>
                    </div>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </ion-card>

            <div [hidden]="grupo.proximaReuniao">
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-list>
                      <sem-registro [text]="'Nenhuma Reunião localizada!'"></sem-registro>
                    </ion-list>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>

            <div class="header-name" *ngIf="grupo.proximaReuniao && grupo.proximaReuniao.links.length > 0 
              && (!userProvider.hasConfig(133) || (userProvider.hasConfig(133) && grupo.permissaoEditar))"
              style="padding: 13px;">
              <div>
                <ion-note>
                  <i class="fas fa-unlink div-icon"></i>
                </ion-note>

                <ion-label class="color-anexo">{{'Anexos da Reunião' | translate}}</ion-label>
              </div>

              <ion-list *ngIf="grupo.proximaReuniao && grupo.proximaReuniao.links" class="link-content">
                <ion-item *ngFor="let link of grupo.proximaReuniao.links" class="text-list" (click)="openLink(link)">
                  {{link.nome}}

                  <ion-note slot="end">
                    <i class="fa-regular fa-arrow-up-right-from-square icon-list"></i>
                  </ion-note>
                </ion-item>
              </ion-list>
            </div>
          </div>
        </div>

        <div *ngSwitchCase="'reunioesFinalizada'">
          <div class="gradient-extendido-div">
            <ion-item class="item-top" lines="none">
              <ion-note slot="start">
                <i class="fas fa-calendar-check div-icon" style="margin-top: 2px;"></i>
              </ion-note>

              <ion-label class="color-title">
                {{'Reuniões Finalizadas' | translate}}
              </ion-label>

              <ion-note (click)="orderDescAsc()" slot="end">
                <i class="fa-regular fa-arrow-down-arrow-up div-icon"></i>
              </ion-note>
            </ion-item>

            <ion-row class="filter">
              <ion-col>
                <ion-button id="filtrar" (click)="openModal = true" shape="round" fill="outline" size="small" color="medium"
                  class="button-filter">
                  {{'Filtrar' | translate}}
                  <i *ngIf="!openModal" class="fa-solid fa-chevron-down edit-icon-chevron"></i>
                  <i *ngIf="openModal" class="fa-solid fa-chevron-up edit-icon-chevron"></i>
                </ion-button>
              </ion-col>
            </ion-row>


            <div *ngIf="reunioesPassadas.length > 0">
              <ion-card class="card-reuniao" *ngFor="let reuniao of reunioesPassadas">
                <ion-grid>
                  <ion-row class="border-row">
                    <ion-col>
                      <div>
                        <p class="titulo">
                          {{reuniao.tema}}
                        </p>

                        <span class="data">
                          {{ reuniao.dataInicio | dateFormat: 'EEE, MMM d, yyyy' }} - {{ reuniao.dataInicio | dateFormat: 'hora' }}
                          - {{ reuniao.dataFim | dateFormat: 'hora'}}
                        </span>
                      </div>
                    </ion-col>  
                  </ion-row>

                  <ion-row class="top=margin">
                    <ion-col>
                      <span class="responsavel-reuniao">
                        {{reuniao.responsavel ? reuniao.responsavel : ('Não Informado' |
                        translate)}}
                      </span>
                    </ion-col>

                    <ion-col size="auto">
                      <div class="presenca">
                        <ion-icon class="icon-card" name="people"></ion-icon>

                        <span [hidden]="reuniao.numPresentes >= 1">
                          {{'Sem presenças confirmadas' | translate}}
                        </span>

                        <span [hidden]="reuniao.numPresentes == 0">
                          {{ reuniao.numPresentes }} {{ (reuniao.numPresentes > 1 ? 'Convidados' : 'Convidado') | translate }}!
                        </span>
                      </div>
                    </ion-col>
                  </ion-row>

                  <ion-row class="ion-justify-content-center">
                    <ion-col size="6">
                      <div
                        *ngIf="reuniao.pauta && (!userProvider.hasConfig(111) || (userProvider.hasConfig(111) && grupo.permissaoEditar))"
                      >
                        <ion-button
                          class="btn-pauta"
                          expand="block"
                          size="default"
                          fill="outline"
                          (click)="abrirPauta(reuniao)"
                          style="font-size: 12px !important;"
                        >
                          {{'Visualizar Pauta' | translate}}
                        </ion-button>
                      </div>
                    </ion-col>
                  </ion-row>
                </ion-grid>
              </ion-card>
            </div>

            <div [hidden]="reunioesPassadas">
              <ion-grid>
                <ion-row>
                  <ion-col>
                    <ion-list>
                      <sem-registro [text]="'Nenhuma Reunião localizada!'"></sem-registro>
                    </ion-list>
                  </ion-col>
                </ion-row>
              </ion-grid>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'gerenciar'">
      <div *ngIf="grupo.proximaReuniao">
        <ion-grid>
          <ion-row>
            <ion-col>
              <div class="proxima-reuniao-header">
                <div class="icon-text-container">
                  <i class="fas fa-calendar-week div-icon"></i>

                  <div class="text-content">
                    <ion-label class="color-title">
                      {{ 'Próxima Reunião' | translate }}
                    </ion-label>

                    <p class="description-text">
                      {{ grupo.proximaReuniao.data | dateFormat:"ddmmyyyy" }} às {{ grupo.proximaReuniao.dataInicio | dateFormat: 'hora'}}
                    </p>
                  </div>
                </div>
              </div>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(107);" (click)="editarPauta(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-square-pen icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Editar Pauta' | translate}}</p>
                  </ion-label>

                   <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(107);" (click)="editarReuniao(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-pen-to-square icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Editar Reunião' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(172);" (click)="presencaParticipantes(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-square-check icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Presença Participantes' | translate}}</p>
                  </ion-label>

                   <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(167);" (click)="presencaVisitantes(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-user-check icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Presença Visitantes' | translate}}</p>
                  </ion-label>

                   <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(168);" (click)="visitanteEsporadico(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-user-clock icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Visitantes Esporádicos' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(174) && resumoData" (click)="resumo(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-square-list icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Resumo da Reunião' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(169);" (click)="addFoto(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-camera icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Fotos da Reunião' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(170);" (click)="check(grupo.proximaReuniao.id)">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-circle-check icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Check-in e Check-out' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(55)" (click)="addReuniao()">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-square-plus icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Adicionar Nova Reunião' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>

      <div class="gradient-extendido-div">
        <div class="div-top">
          <ion-note slot="start">
            <i class="fas fa-users-cog div-icon" style="margin-top: 2px;"></i>
          </ion-note>

          <ion-label class="color-title">
            {{'Gerenciar' | translate}}
            {{(getNomenclatura(tipo) | nomenclatura | async)}}
          </ion-label>
        </div>

        <ion-grid>
          <ion-row *ngIf="!userProvider.hasConfig(173);" (click)="gerenciarReunioes();">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-calendar-lines-pen icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Gerenciar Reuniões' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row (click)="gerenciarParticipantes();"
            *ngIf="!userProvider.hasConfig(185)"
          >
            <ion-col size="12" 
              *ngIf="userProvider.hasConfig(122) || userProvider.hasConfig(123) || userProvider.hasConfig(124)"
            >
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-user-gear icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Gerenciar Participantes' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(179)">
            <ion-col size="12"
              *ngIf="userProvider.hasConfig(119) || userProvider.hasConfig(120) || userProvider.hasConfig(121) || userProvider.hasConfig(125)"
              (click)="gerenciarVisitantes();">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-user-check icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list"> {{'Gerenciar Visitantes' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="gerenciar">
            <ion-col size="12" (click)="gerenciarSolicitacao();">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-user-check icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Gerenciar Solicitações Administrativas' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="visualizar" (click)="gerenciarCaixa();">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-money-bill-simple-wave icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Gerenciar Caixa' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!userProvider.hasConfig(171);" (click)="gerenciarGraficos();">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-chart-line-up icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Gráficos' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="(grupo.permissaoFeedback && userProvider.hasConfig(76))" class="item-description2"
            (click)="feedback();">
            <ion-col size="12">
              <ion-list lines="full">
                <ion-item>
                  <ion-note slot="start">
                    <i class="fa-solid fa-comments icon-list icon-gerenciar"></i>
                  </ion-note>

                  <ion-label>
                    <p class="text-list">{{'Feedback' | translate}}</p>
                  </ion-label>

                  <i class="fa-regular fa-chevron-right icon-list"></i>
                </ion-item>
              </ion-list>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
    </div>
  </div>

  <ion-fab horizontal="end" vertical="bottom" slot="fixed" *ngIf="showAddMensagem && (grupo.permissaoEditar || isMensagemParticipante)"
    (click)="novaMensagem();">
    <ion-fab-button class="ion-fab">
      <i class="fa-regular fa-plus"></i>
    </ion-fab-button>
  </ion-fab>
</ion-content>

<ion-footer class="footer-segment reunioes-finalizadas" *ngIf="loaded && showReuniao">
  <ion-segment
    style="margin: 0; width: 100%"
    [(ngModel)]="grupoTabReuniao"
    [scrollable]="true"
    value="reunioesAtuais"
    mode="ios"
  >
    <ion-segment-button value="reunioesAtuais">
      <ion-label>
        <i class="fa-solid fa-calendar-clock"></i>
        <p>{{'Próxima Reunião' | nomenclatura | async}}</p>
      </ion-label>
    </ion-segment-button>

    <ion-segment-button value="reunioesFinalizada">
      <ion-label>
        <i class="fas fa-calendar-check"></i>
        <p>{{'Reuniões Finalizadas' | translate}}</p>
      </ion-label>
    </ion-segment-button>
  </ion-segment>
</ion-footer>

<ion-modal [isOpen]="openModal" (didDismiss)="open()" [initialBreakpoint]="1" [breakpoints]="[0, 1]">
  <ng-template>
    <div class="ion-padding-horizontal ion-margin-top">
      <prover-datepicker
        [labelName]="'Data Início'"
        [id]="'dataInicio'"
        [(dateTime)]="dataInicio"
        [required]="false"
        [isDataAtual]="true"
      ></prover-datepicker>
    </div>

    <div class="ion-padding-horizontal">
      <prover-datepicker
        [labelName]="'Data Fim'"
        [id]="'dataFim'"
        [(dateTime)]="dataFim"
        [required]="false"
        [isDataAtual]="true"
      ></prover-datepicker>
    </div>

    <div class="down" (click)="filtrar()">
      <ion-button class="btn-default" expand="block"> {{'Filtrar' | translate }} </ion-button>
    </div>
  </ng-template>
</ion-modal>